import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./StoreLocator.module.css";
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import googleLocationIcon from "../../Components/Assets/icon/contact_googleLocation.svg";
import API_BASE_URL from "../../config/api";

const StoreLocator = () => {
  const [storeLocations, setStoreLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/getStoreLocation.php`)
      .then((response) => {
        if (response.data.success) {
          setStoreLocations(response.data.stores);
        } else {
          setError(response.data.message || "Failed to fetch store locations.");
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        // Check if the error has a response from the server
        if (error.response) {
          console.error("Response Error:", error.response);
          setError(
            "Server Error: " +
              (error.response.data.message || error.response.statusText)
          );
        }
        // Check if the request was made but no response was received
        else if (error.request) {
          console.error("Request Error:", error.request);
          setError("Network Error: Unable to reach the server.");
        }
        // Any other errors
        else {
          console.error("Error Message:", error.message);
          setError("Failed to fetch store locations.");
        }
      });
  }, []);

  if (loading) return <p>Loading store locations...</p>;
  if (error) return <p>{error}</p>;

  // Base URL for the images
  const imageBaseUrl = `${API_BASE_URL}/uploads/storeLocator/`;

  return (
    <div>
      {/* Updated Design for the Header */}
      <div 
        className={styles.storeLocator_container}
        style={{backgroundImage: `url(${API_BASE_URL}/uploads/headerImg/bodyfriend_outlet.jpg)`}}
      >
        <h1 className={styles.title}>Our Store</h1>
        <p className={styles.subtitle}>
          Discover comfort near you with our massage chair!
        </p>
      </div>

      {/* Card container */}
      <div className={styles.cardContainer}>
        {/* Shows the store locations */}
        <div className={styles.grid}>
          {storeLocations.length > 0 ? (
            storeLocations.map((store) => (
              <div key={store.id} className={styles.card}>
                {/* Store Image */}
                <div className={styles.imageContainer}>
                  <img
                    src={`${imageBaseUrl}${store.image_url}`} // Dynamically prepend the full path to the filename stored in the DB
                    alt={store.name}
                    className={styles.storeImage}
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop in case fallback image is also broken
                      e.target.src = "fallback_image_path.jpg"; // Replace with your fallback image URL
                    }}
                  />
                </div>

                <div className={styles.wrapTextContent}>
                  <h2>{store.name}</h2>

                  {/* Location details */}
                  <div className={styles.wrapTextIcon}>
                    <FaMapMarkerAlt size={15} className={styles.icon} />
                    <span className={styles.wrapText}>{store.unit_code}</span>
                  </div>

                  {/* Contact details */}
                  <div className={styles.wrapTextIcon}>
                    <FaPhoneAlt size={15} className={styles.icon} />
                    <span className={styles.wrapText}>{store.tel_no}</span>
                  </div>

                  {/* Email */}
                  <div className={styles.wrapTextIcon}>
                    <FaEnvelope size={15} className={styles.icon} />
                    <span className={styles.wrapText}>{store.email}</span>
                  </div>

                  {/* Google Maps link */}
                  <div className={styles.maps}>
                    <a
                      href={store.google_map_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={googleLocationIcon}
                        alt="Google Maps"
                        className={styles.mapIcon}
                      />
                      <span>View on Google Maps</span>
                    </a>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className={styles.noStoresContainer}>
              <p>No stores available at the moment.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StoreLocator;
